import styled from 'styled-components';

export const SectionTitle = styled.h3`
  color: ${({ theme }) => theme.colors.black9};

  font-size: 14px;
  font-weight: 500;
  line-height: 20px;

  &:first-child {
    margin-top: 0;
  }
`;
